// Indian number + currency formatting utilities.

export function indianGroup(value) {
  const neg = value < 0;
  let n = Math.abs(Math.round(value || 0)).toString();
  if (n.length <= 3) return (neg ? "-" : "") + n;
  const last3 = n.slice(-3);
  let rest = n.slice(0, -3);
  rest = rest.replace(/\B(?=(\d{2})+(?!\d))/g, ",");
  return (neg ? "-" : "") + rest + "," + last3;
}

// mode: 'crore' (compact: Cr / L) or 'full' (full Indian grouping)
export function formatMoney(value, mode = "crore", { withSymbol = true } = {}) {
  if (value === null || value === undefined || isNaN(value)) return "\u2014";
  const sym = withSymbol ? "\u20b9" : "";
  const neg = value < 0;
  const abs = Math.abs(value);
  const sign = neg ? "-" : "";
  if (mode === "crore") {
    if (abs >= 1e7) return `${sign}${sym}${(abs / 1e7).toFixed(2)} Cr`;
    if (abs >= 1e5) return `${sign}${sym}${(abs / 1e5).toFixed(2)} L`;
    return `${sign}${sym}${indianGroup(abs)}`;
  }
  return `${sign}${sym}${indianGroup(abs)}`;
}

export function formatPercent(value, decimals = 1) {
  if (value === null || value === undefined || isNaN(value)) return "\u2014";
  return `${(value * 100).toFixed(decimals)}%`;
}

export function formatCount(value) {
  if (value === null || value === undefined || isNaN(value)) return "0";
  return indianGroup(value);
}

// Compact INR for chart axes (independent of currency mode)
export function axisINR(value) {
  if (value === null || value === undefined || isNaN(value)) return "0";
  const v = Math.abs(value);
  const sign = value < 0 ? "-" : "";
  if (v >= 1e7) return `${sign}${(v / 1e7).toFixed(1)}Cr`;
  if (v >= 1e5) return `${sign}${(v / 1e5).toFixed(0)}L`;
  if (v >= 1e3) return `${sign}${(v / 1e3).toFixed(0)}k`;
  return `${sign}${Math.round(v)}`;
}

// Compact integer for count axes
export function axisCount(value) {
  if (value === null || value === undefined || isNaN(value)) return "0";
  const v = Math.abs(value);
  if (v >= 1e5) return `${(v / 1e5).toFixed(1)}L`;
  if (v >= 1e3) return `${(v / 1e3).toFixed(1)}k`;
  return `${Math.round(v)}`;
}

export function formatDate(iso) {
  if (!iso) return "\u2014";
  try {
    const d = new Date(iso);
    return d.toLocaleDateString("en-IN", { day: "2-digit", month: "short", year: "numeric" });
  } catch (e) {
    return iso;
  }
}
